import { render } from "./FormRegister.vue?vue&type=template&id=6ee4c4de&scoped=true"
import script from "./FormRegister.vue?vue&type=script&lang=js"
export * from "./FormRegister.vue?vue&type=script&lang=js"

import "./FormRegister.vue?vue&type=style&index=0&id=6ee4c4de&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/colordemy-customers/colordemy-customers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee4c4de"]])

export default __exports__